import React from 'react';
import { captureHeapEvent, HEAP_EVENT_NAMES } from '@blocs.heap';
import { PaywallButton } from '@minecraft.atoms';
import { useDeviceAndBrowserInfo } from '@minecraft.utils';
import { useTranslation } from '@blocs.i18n';

interface SocialPaywallButtonProps {
  eventSourcePage: string;
  toggleSocialPaywallConsentModal: () => void;
}

export const SocialPaywallButton = ({ toggleSocialPaywallConsentModal, eventSourcePage }: SocialPaywallButtonProps) => {
  const { t } = useTranslation();
  const { deviceInfo, browserInfo } = useDeviceAndBrowserInfo();
  return (
    <PaywallButton
      onClick={() => {
        toggleSocialPaywallConsentModal();
        captureHeapEvent({
          name: HEAP_EVENT_NAMES.TALENT_SOCIAL_CLICK_UPGRADE_TO_PREMIUM,
          data: {
            timestamp: new Date().toISOString(),
            device: deviceInfo,
            browser: browserInfo,
            location: eventSourcePage,
          },
        });
      }}
      label={{ name: t('common:membership.upgradeToPremiumShort'), justify: 'start' }}
      startIcon={{ name: 'rocket', justify: 'end' }}
      color="hotTrial"
      isSmall
      fixedWidth
      data-testid="consent-modal-button"
    />
  );
};
